/**
 * The builder page: the form on the left and the live plan in a sticky panel
 * on the right, so the numbers stay in view while the seller edits. Below
 * 1100px there is no room for the panel, so it comes last in the page instead
 * — never a bar pinned over the form.
 */

import React from 'react';
import { Card } from '../../../ui';
import { useMediaQuery } from '../../../../hooks/useViewport';

export const SIDE_PANEL_QUERY = '(min-width: 1100px)';

interface Props {
  /** Banners above everything (restored draft, new version, chat draft). */
  header?: React.ReactNode;
  form: React.ReactNode;
  summary: React.ReactNode;
}

const BuilderLayout: React.FC<Props> = ({ header, form, summary }) => {
  const wide = useMediaQuery(SIDE_PANEL_QUERY);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {header}
      <div style={wide ? styles.grid : styles.stack}>
        <Card style={styles.form}>{form}</Card>
        <aside aria-label="Live plan" style={wide ? styles.aside : undefined}>
          {summary}
        </aside>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  grid: { display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 360px', gap: 16, alignItems: 'start' },
  stack: { display: 'flex', flexDirection: 'column', gap: 16 },
  form: { display: 'flex', flexDirection: 'column', gap: 22, minWidth: 0 },
  aside: { position: 'sticky', top: 16, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto' },
};

export default BuilderLayout;
